import { useEffect, useState } from "react";
import { getCustomisationValue } from "../../../EditablePreview/EditablePreview";
import ModuleNumericalInput from "../../components/ModuleNumericalInput";
import { changeNumericalFieldValue, changeStringFieldValue, changeValue_noType } from "../../ModuleList";
import { renderFirstCustomBlock, renderSecondCustomBlock } from "../../customFields/CustomFieldRenderer";
import ModuleTextInput from "../../components/ModuleTextInput";
import Toggle from "../../customFields/toggle/toggleSwitch/Toggle";
import RangeSlider from "../../customFields/rangeSlider/slider/RangeSlider";
import AudioField from "../../customFields/audio/AudioField";

const AudioModule = (props) => {
    const moduleConfig = props.moduleConfig;
    const customisationVars = props.customisationVars;

    console.log("AudioModule: Rendering with moduleConfig:", moduleConfig, "and customisationVars:", customisationVars, props);

    const nameDataLink = moduleConfig['audio-name'] ?? moduleConfig?.fields?.[0]?.dataLink;
    const enabledDataLink = moduleConfig['audio-enabled'] ?? moduleConfig?.fields?.[1]?.dataLink;
    const audioFileDataLink = moduleConfig['audio-file'] ?? moduleConfig?.fields?.[2]?.dataLink;
    const loopDataLink = moduleConfig['audio-loop'] ?? moduleConfig?.fields?.[4]?.dataLink;
    const delayDataLink = moduleConfig['audio-delay'] ?? moduleConfig?.fields?.[5]?.dataLink;
    const volumeDataLink = moduleConfig['audio-volume'] ?? moduleConfig?.fields?.[3]?.dataLink;

    console.log(nameDataLink, enabledDataLink, audioFileDataLink, loopDataLink, delayDataLink, volumeDataLink);

    const [name, setName] = useState(getCustomisationValue(customisationVars, nameDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [enabled, setEnabled] = useState(getCustomisationValue(customisationVars, enabledDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [audioFile, setAudioFile] = useState(getCustomisationValue(customisationVars, audioFileDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [loop, setLoop] = useState(getCustomisationValue(customisationVars, loopDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [delay, setDelay] = useState(getCustomisationValue(customisationVars, delayDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);
    const [volume, setVolume] = useState(getCustomisationValue(customisationVars, volumeDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null);

    useEffect(() => {
        if (nameDataLink) {
            const nameValue = getCustomisationValue(customisationVars, nameDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setName(nameValue);
        }
    }, [nameDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);
    useEffect(() => {
        if (enabledDataLink) {
            const enabledValue = getCustomisationValue(customisationVars, enabledDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setEnabled(enabledValue);
        }
    }, [enabledDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);
    useEffect(() => {
        if (audioFileDataLink) {
            const audioFileValue = getCustomisationValue(customisationVars, audioFileDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setAudioFile(audioFileValue);
        }
    }, [audioFileDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);
    useEffect(() => {
        if (loopDataLink) {
            const loopValue = getCustomisationValue(customisationVars, loopDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setLoop(loopValue);
        }
    }, [loopDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);
    useEffect(() => {
        if (delayDataLink) {
            const delayValue = getCustomisationValue(customisationVars, delayDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setDelay(delayValue);
        }
    }, [delayDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);
    useEffect(() => {
        if (volumeDataLink) {
            const volumeValue = getCustomisationValue(customisationVars, volumeDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            setVolume(volumeValue);
        }
    }, [volumeDataLink, customisationVars, props.index, props.visualisationComponentKey, props.selectedFeatureNode]);

    const changeVolumeFieldValue = (value) => {
        if (volumeDataLink) {
            if (changeNumericalFieldValue(customisationVars, { dataLink: volumeDataLink }, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setVolume(value);
            }
        }
    };
    const changeDelayFieldValue = (value) => {
        if (delayDataLink) {
            if (changeNumericalFieldValue(customisationVars, { dataLink: delayDataLink }, value, true, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setDelay(value);
            }
        }
    };
    const changeLoopFieldValue = (value) => {
        if (loopDataLink) {
            if (changeValue_noType(customisationVars, { dataLink: loopDataLink }, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setLoop(value);
            }
        }
    };
    /* const changeAudioFileFieldValue = (value) => {
        if (audioFileDataLink) {
            if (changeStringFieldValue(customisationVars, { dataLink: audioFileDataLink }, value, false, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setAudioFile(value);
            }
        }
    }; */
    const changeNameFieldValue = (value) => {
        if (nameDataLink) {
            if (changeStringFieldValue(customisationVars, { dataLink: nameDataLink }, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setName(value);
            }
        }
    };
    const changeEnabledFieldValue = (value) => {
        if (enabledDataLink) {
            if (changeValue_noType(customisationVars, { dataLink: enabledDataLink }, value, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
                setEnabled(value);
                props.forceUpdateComponent();
            }
        }
    };

    /* const clickHandler = () => {
        props.openTemporaryAudioUploadPopup(
            audioFile,
            'Timeline Audio > ' + (name || 'Unnamed Audio'),
            'This is a temporary audio uploader and is not final.',
        )
    } */

    return (
        <div className="v2-basic-module-holder">
            <div className="fl-row">
                <h4>Audio</h4>
                {/* <div className="grow"></div>
                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Enabled</div>
                </div>
                <div className='v2-module-one-column'>
                    <div className={`v2-field-holder${!enabledDataLink ? ' v2-module-disabled-field' : ''}`}>
                        <Toggle
                            value={enabled}
                            onToggle={enabledDataLink ? () => changeEnabledFieldValue(!enabled) : null}
                        />
                    </div>
                </div> */}
            </div>
            {/* renderFirstCustomBlock(props) */}

            <div className='v2-module-columns-holder wrap'>

                <div className='v2-module-one-column v2-full-width'>
                    <div className='v2-module-field-label'>Name</div>
                    <ModuleTextInput
                        value={getCustomisationValue(customisationVars, nameDataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? 'N/a'}
                        fieldId={'audio-name-field'}
                        enabled={nameDataLink}
                        editable={true}
                        onChange={(fieldId, value) => {changeNameFieldValue(value);}}
                    />
                </div>

                <div className='v2-module-one-column v2-full-width'>
                    <AudioField
                        fieldData={{ customFieldConfig: { dataLink: audioFileDataLink, customFieldLabel: 'Audio File' } }}
                        moduleConfig={moduleConfig}
                        groupConfig={props.groupConfig}
                        customisationVars={customisationVars}
                        index={props.index}
                        visualisationComponentKey={props.visualisationComponentKey}
                        selectedFeatureNode={props.selectedFeatureNode}
                        isEnabled={!!audioFileDataLink}
                        openTemporaryAudioUploadPopup={props.openTemporaryAudioUploadPopup}
                    />
                    {/* <div className='v2-module-field-label'>Audio File</div>
                        <ModuleTextInput
                            fieldLabel={<div className="v2-module-block-field-input-label" />}
                            value={typeof audioFile === 'string' ? audioFile : audioFile?.originalFile ?? '<No File>'}
                            fieldId={'audio-file'}
                            // enabled={props.isEnabled}
                            editable={false}
                            onChange={null}
                            onClick={
                                clickHandler
                            }
                        /> */}
                </div>

                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Enabled</div>
                    <div className={`v2-field-holder${!enabledDataLink ? ' v2-module-disabled-field' : ''}`}>
                        <Toggle
                            value={enabled}
                            onToggle={enabledDataLink ? () => changeEnabledFieldValue(!enabled) : null}
                        />
                    </div>
                </div>

                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Loop</div>
                    <div className={`v2-field-holder${!loopDataLink ? ' v2-module-disabled-field' : ''}`}>
                        <Toggle
                            value={loop}
                            onToggle={loopDataLink ? () => changeLoopFieldValue(!loop) : null}
                        />
                    </div>
                </div>

                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Volume</div>
                    <div className={`v2-field-holder${!volumeDataLink ? ' v2-module-disabled-field' : ''}`}>
                        <RangeSlider
                            min={0}
                            max={100}
                            value={volume}
                            onChange={volumeDataLink ? (e) => changeVolumeFieldValue(e.target.value) : null}
                        />
                    </div>
                </div>

                <div className='v2-module-one-column'>
                    <div className='v2-module-field-label'>Delay (ms)</div>
                    <ModuleNumericalInput
                        value={delay}
                        fieldId={'audio-delay-field'}
                        enabled={!!delayDataLink}
                        onChange={(fieldId, value) => changeDelayFieldValue(value)}
                        hiddenDropDown={true}
                        hiddenDropDownOptions={[0, 100, 250, 500, 750, 1000, 1500, 2000]}
                        dropDownValue={delay}
                    />
                </div>

            </div>

            {/* renderSecondCustomBlock(props) */}
        </div>
    );
};

export default AudioModule;
